import ApiService from '../api.service';

const SchoolClasses = {
  index: () => ApiService.get('/api/v2/principals/me/school_classes/'),
  show: paramsId => ApiService.get(`/api/v2/principals/me/school_classes/${paramsId}`),
};

export default SchoolClasses;
